import Dialog from "./Dialog";
import useAuth from "../../hooks/useAuth";
import { useEffect, useState } from "react";
import useAuthLoginFlow from "../../hooks/useAuthLoginFlow";
import useAppModernisation from "../../hooks/useAppModernisation";

const LoginAlertDialog = ({bodyText}) => {
  const { isLogged, b2cDisabled } = useAuth();
  const { isAppMode } = useAppModernisation();
  const [isOpen, setIsOpen] = useState(false);
  const { handleLoginClick } = useAuthLoginFlow();

  useEffect(() => {
    setIsOpen(isAppMode && !isLogged && !b2cDisabled);
  }, [isAppMode, isLogged, b2cDisabled]);

  return (
    <Dialog
      bodyText={bodyText || "Please log in to view contents"}
      confirmFunction={handleLoginClick}
      heading="Log in"
      buttonText="Login"
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    ></Dialog>
  );
};

export default LoginAlertDialog;